<template>
  <div class="d-flex align-items-center justify-content-between">
    <div>
      <h1 class="mb-0">{{ application?.titel }}</h1>
    </div>
    
    <div v-if="application?.id != 0" class="d-flex align-items-center">
      <EditApplicationModal :application="application" :index="0" :buttonStyle="2" @delete-application="deleteApplication" />
    </div>
  </div>


</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, onMounted, PropType, watch } from 'vue';
  import { useRouter } from 'vue-router';

  import EditApplicationModal from '@/components/Applications/EditApplicationModal.vue';

  import { useApplicationsStore } from '@/stores/applicationsStore';
  import { Application } from '@/models/ApplicationsModels';
  //#endregion

  const { id } = defineProps({
    id: {
      type: Number as PropType<number>,
      required: true
    }
  })

  const router = useRouter();
  
  const applicationsStore = useApplicationsStore();
  const application = computed(() => applicationsStore.applications.find((u: Application) => u.id === id));

  function deleteApplication() {
    applicationsStore.deleteApplication(application.value.id).then(() => {
      router.push({ name: 'Applications' });
    });
  }

  watch(
    () => id,
    async () => {
      if (id) {
        console.log("Do Something with id:", id);
      }
    },
  );

  onMounted(async () => {
    if (applicationsStore.applications.length === 0) {
      await applicationsStore.getApplications();
    }
  });
</script>
